import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';

// Modules Material utilises
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';

// Autres modules externes utilises 

// Modules communs utilises

// Composants metiers
import { ImportButtonComponent } from './component/import-button.component';
import { ImportDialogComponent } from './component/import-dialog.component';

// Services metier

// Bridges avec la partie angular
import * as angular from 'angular';
import { downgradeComponent } from '@angular/upgrade/static';

@NgModule({
	imports: [
		BrowserModule,
		FormsModule,
		
		MatDialogModule,
		MatIconModule,
	],
	providers: [
	],
	declarations: [
		ImportButtonComponent,
		ImportDialogComponent,
	],
	exports: [
		ImportButtonComponent,
	]
})
export class DataImportModule {
	constructor() { }
}

angular.module('auroraApp') //
	.directive('importButton',
		downgradeComponent({ component: ImportButtonComponent })
	) //
;